import { useDefaultModuleActions } from "../../common"
import { TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { useSystemStateHooks } from "../../system"
import { DynamoUserApi } from "../../../services"
import { Lot } from "../state/types"

export const useLotsActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const defaultModuleActions = useDefaultModuleActions()

    return (paramCompanyId?: string) => {
        const companyId = define(paramCompanyId || stateCompanyId)
        const { fetchAll, save, remove } = defaultModuleActions(DynamoUserApi, companyId)

        const fetchAllLots = async () => {
            return fetchAll(TableName.LOTS) as Promise<Lot[]>
        }

        const saveLot = (lot: Lot) => {
            return save(TableName.LOTS, lot)
        }

        const removeLot = (id: string) => {
            return remove(TableName.LOTS, id)
        }

        return {
            fetchAllLots,
            saveLot,
            removeLot
        }
    }
}
